import React, { Fragment, useState } from 'react';

import '../index.css';
import lupa from '../../../../../assets/images/lupaReport.svg';
import OrgTotalBotsUser from './Components/OrgTotalBotsUser';
import OrgAverageUsersBotsReport from './Components/Report/OrgAverageUsersBotsReport';

/**
 * Component for hold the components used on the bots per user screen
 *
 * @returns
 */
const OrgBotsUserScreen = () => {
  const [textFilter, setTextFilter] = useState('');

  /**
   * Called when the search term input change
   * @param {*} event
   */
  const onChangeInputSearch = (event) => {
    setTextFilter(event.target.value);
  };

  return (
    <Fragment>
      <div className="container-input-bots-users">
        <div className="cont-ipt-bots">
          <img src={lupa} />
          <input
            placeholder="Pesquisar"
            className="input-bots-users"
            onChange={onChangeInputSearch}
          />
        </div>
      </div>
      <div className="container-popup-bots-users">
        <OrgAverageUsersBotsReport />
        <OrgTotalBotsUser searchTerm={textFilter} />
      </div>
    </Fragment>
  );
};

export default OrgBotsUserScreen;
